import { DateTime } from 'luxon';
import type { ILinkEndpoint } from '../models/link-endpoint.model';

export default class LinkEndpointHelper {
  public static getTime(accessLinkEndpoint: ILinkEndpoint, useEstimatedTime: boolean): DateTime | undefined {
    if (!accessLinkEndpoint) {
      return undefined;
    }

    if (useEstimatedTime) {
      return accessLinkEndpoint.estimatedTime ? accessLinkEndpoint.estimatedTime : accessLinkEndpoint.plannedTime;
    }
    return accessLinkEndpoint.plannedTime;
  }

  public static isOnTime(accessLinkEndpoint: ILinkEndpoint): boolean {
    return !accessLinkEndpoint.estimatedTime || accessLinkEndpoint.estimatedTime.equals(accessLinkEndpoint.plannedTime);
  }
}
